import React, { useState } from 'react';
import './Resources.css';

// Define resources; categories can now be arrays
const resources = [
  {
    title: 'Alberta Curriculum Math Focus 7 Textbook',
    description: 'Available on our Google Classroom. Accessible to tutors only.',
    link: 'https://classroom.google.com/c/MjM4MzUzMjM4MjMy/m/ODM4ODcyNjUxODk4/details',
    categories: ['Tutor'],
  },
  {
    title: 'Alberta Curriculum Math Makes Sense 7 Textbook',
    description: 'Available on our Google Classroom. Accessible to tutors only.',
    link: 'https://classroom.google.com/c/MjM4MzUzMjM4MjMy/m/ODI0MzMyNTg2MDMy/details',
    categories: ['Tutor'],
  },
  {
    title: 'Alberta Curriculum Math MHR 7 Textbook',
    description: 'Available on our Google Classroom. Accessible to tutors only.',
    link: 'https://classroom.google.com/c/MjM4MzUzMjM4MjMy/m/MjgyMzk3MjQ1OTc3/details',
    categories: ['Tutor'],
  },
  {
    title: 'Alberta Curriculum Math Focus 8 Textbook',
    description: 'Available on our Google Classroom. Accessible to tutors only.',
    link: 'https://classroom.google.com/c/MjM4MzUzMjM4MjMy/m/NzkzMTU3MTk2Njgz/details',
    categories: ['Tutor'],
  },
  {
    title: 'Alberta Curriculum Math Makes Sense 8 Textbook',
    description: 'Available on our Google Classroom. Accessible to tutors only.',
    link: 'https://classroom.google.com/c/MjM4MzUzMjM4MjMy/m/ODM4ODczMzk0NDM2/details',
    categories: ['Tutor'],
  },
  {
    title: 'Alberta Curriculum Math MHR 8 Textbook',
    description: 'Available on our Google Classroom. Accessible to tutors only.',
    link: 'https://classroom.google.com/c/MjM4MzUzMjM4MjMy/m/MjgyMzk3MjQ1ODUx/details',
    categories: ['Tutor'],
  },
  {
    title: 'Alberta Curriculum Math Links 9 Textbook',
    description: 'Available on our Google Classroom. Accessible to tutors only.',
    link: 'https://classroom.google.com/c/MjM4MzUzMjM4MjMy/m/ODI0MzMyNzE3NjY2/details',
    categories: ['Tutor'],
  },
  {
    title: 'Alberta Curriculum Math Makes Sense 9 Textbook',
    description: 'Available on our Google Classroom. Accessible to tutors only.',
    link: 'https://classroom.google.com/c/MjM4MzUzMjM4MjMy/m/ODM4ODczNjgzNDAx/details',
    categories: ['Tutor'],
  },
  {
    title: 'Alberta Curriculum Science Focus 7 Textbook',
    description: 'Available on our Google Classroom. Accessible to tutors only.',
    link: 'https://classroom.google.com/c/MjM4MzUzMjM4MjMy/m/ODM4ODc3MzY4MjY1/details',
    categories: ['Tutor'],
  },
  {
    title: 'Alberta Curriculum Science in Action 7 Textbook',
    description: 'Available on our Google Classroom. Accessible to tutors only.',
    link: 'https://classroom.google.com/c/MjM4MzUzMjM4MjMy/m/NzkzMTU3ODI1NzY5/details',
    categories: ['Tutor'],
  },
  {
    title: 'Alberta Curriculum Science Focus 8 Textbook',
    description: 'Available on our Google Classroom. Accessible to tutors only.',
    link: 'https://classroom.google.com/c/MjM4MzUzMjM4MjMy/m/ODM4ODc2ODU3NjAw/details',
    categories: ['Tutor'],
  },
  {
    title: 'Alberta Curriculum Science in Action 8 Textbook',
    description: 'Available on our Google Classroom. Accessible to tutors only.',
    link: 'https://classroom.google.com/c/MjM4MzUzMjM4MjMy/m/ODM4ODczMzIxOTI4/details',
    categories: ['Tutor'],
  },
  {
    title: 'Alberta Curriculum Science Focus 9 Textbook',
    description: 'Available on our Google Classroom. Accessible to tutors only.',
    link: 'https://classroom.google.com/w/MjM4MzUzMjM4MjMy/tc/MjM4NDExMDk5MDU4',
    categories: ['Tutor'],
  },
  {
    title: 'Alberta Curriculum Science in Action 9 Textbook',
    description: 'Available on our Google Classroom. Accessible to tutors only.',
    link: 'https://classroom.google.com/c/MjM4MzUzMjM4MjMy/m/NzkzMTU4MDcyNzgy/details',
    categories: ['Tutor'],
  },
  {
    title: 'Frequently Asked Questions (FAQ)',
    description: 'Refer to this document for any questions you may have. If unanswered, send us an email.',
    link: 'https://docs.google.com/document/d/1v0CMHiDNFGFn6RXPhGfEGsM9w3fnXlTFg3KuVINCLB4/edit?usp=sharing',
    categories: ['Tutor', 'Tutee', 'Parent'],
  },
  {
    title: 'Learning Resources',
    description: 'Use this running spreadsheet for extra practice materials and helpful links to use as needed. Suggestions always welcome.',
    link: 'https://docs.google.com/spreadsheets/d/1TXCEJuaNHvTIaQfU9ss8L9KMpGwSdUd5UMZlLtkkXJc/edit?usp=sharing',
    categories: ['Tutor', 'Tutee'],
  },
  {
    title: 'Letter to Tutees',
    description: 'Interested in free tutoring? Read our introductory letter for more information about what we offer and our process.',
    link: 'https://docs.google.com/document/d/1fiXU_gUkYzV5aOoKg9a71yi7f2wV2Wf88j39Bd_ck-E/edit?usp=sharing',
    categories: ['Tutee'],
  },
  {
    title: 'Letter to Tutors',
    description: 'Interested in becoming a tutor? Read our introductory letter for more information about this program and your responsibilites.',
    link: 'https://docs.google.com/document/d/1-ltaVHx_6esMJC6hT5U4OABTWb2sOtpGVWm5UgWmuVM/edit?usp=sharing',
    categories: ['Tutor'],
  },
  {
    title: 'Tutor-Tutee Pairing List',
    description: 'Access the tutor-tutee pairing list. Accessible only to tutors and tutees who are a part of this program.',
    link: 'https://docs.google.com/spreadsheets/d/1cf8w6CE726Nb_b1Pw2vOCBEbgZ5-60gYcAWJotczsTQ/edit?usp=sharing',
    categories: ['Tutor', 'Tutee', 'Parent'],
  },
  // Add more resources here
];

const allCategories = ['All', 'Tutor', 'Tutee', 'Parent'];

export default function Resources() {
  const [filter, setFilter] = useState('All');

  // Filter resources based on selected category
  const filteredResources =
    filter === 'All'
      ? resources
      : resources.filter((res) => res.categories.includes(filter));

  return (
    <div className="resources-container">
      <h1>Resources Hub</h1>
      <p>Access important documents and helpful links for tutors, students, and parents.</p>

      {/* Filter Buttons */}
      <div className="filter-buttons">
        {allCategories.map((cat) => (
          <button
            key={cat}
            className={filter === cat ? 'active' : ''}
            onClick={() => setFilter(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Resources Grid */}
      <div className="resources-grid">
        {filteredResources.map((res, idx) => (
          <a
            key={idx}
            href={res.link}
            target="_blank"
            rel="noopener noreferrer"
            className={`resource-card`}
          >
            <h3>{res.title}</h3>
            <p>{res.description}</p>
            <div className="resource-categories">
              {res.categories.map((cat) => (
                <span key={cat} className={`resource-category ${cat.toLowerCase()}`}>
                  {cat}
                </span>
              ))}
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
